import React, { useState, useRef, useContext, useEffect } from "react";
import { updateDoc, doc, getDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { toast } from "react-toastify";
import { EnvContext } from "../../../context/EnvContext";
import { useFirestore } from "../../firebase/FirestoreContext";
import { useParams } from "react-router-dom";
import config from "../../../config";

const ProductCoaTab = () => {
  const environment = useContext(EnvContext);
  const db = useFirestore();
  const { id } = useParams();

  const collectionPath = environment === "staging" ? config.enveironment.staging.collectionPath : config.enveironment.production.collectionPath;

  // Initialize productData with a default coa field
  const [productData, setProductData] = useState({ coa: "" });
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  // Initialize Firebase Storage
  const storage = getStorage();

  useEffect(() => {
    const fetchProductData = async () => {
      if (id) {
        const productDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase`, id);
        const docSnap = await getDoc(productDocRef);

        if (docSnap.exists()) {
          setProductData(docSnap.data());
        } else {
          console.log("No such document!");
        }
      }
    };

    fetchProductData();
  }, [db, collectionPath, id]);

  const handleFileChange = (e) => {
    // Even if file input is single, convert FileList to array.
    setFiles([...e.target.files]);
  };

  const handleFileUpload = async (event) => {
    event.preventDefault();
    setLoading(true);

    // We assume a single PDF is uploaded (remove multiple attribute if not needed)
    for (const file of files) {
      try {
        // Create a reference in Firebase Storage for this file.
        // You can organize files in folders as needed.
        const storageRef = ref(storage, `products/${id}/coa/${file.name}`);

        // Upload the file to Firebase Storage
        await uploadBytes(storageRef, file);

        // Get the download URL of the uploaded file
        const downloadURL = await getDownloadURL(storageRef);

        // Update productData with the new COA URL
        setProductData((prev) => ({
          ...prev,
          coa: downloadURL,
        }));

        // Update the Firestore document with the new COA URL
        const productDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase`, id);
        await updateDoc(productDocRef, { coa: downloadURL });

        toast.success("COA uploaded successfully!");
      } catch (error) {
        console.error("Error uploading COA:", error);
        toast.error(`Error uploading COA - ${error.message}`);
      }
    }

    // Clear the file input and file list
    fileInputRef.current.value = "";
    setFiles([]);
    setLoading(false);
  };

  const deleteCoa = async () => {
    setLoading(true);
    try {
      const productDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase`, id);
      await updateDoc(productDocRef, { coa: "" });
      setProductData((prev) => ({ ...prev, coa: "" }));
      toast.success("COA deleted successfully!");
    } catch (error) {
      console.error("Error deleting COA:", error);
      toast.error("Error deleting COA");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleFileUpload} style={styles.container}>
      {productData.coa && (
        <>
          <div style={styles.coaPreview}>
            <label style={styles.formLabel}>Current COA:</label>
            <br /> <br />
            <a href={productData.coa} target="_blank" rel="noopener noreferrer">
              View COA
            </a>
            <label type="button" onClick={deleteCoa} disabled={loading} style={{ marginLeft: 10, textDecoration: "underline", color: "red" }}>
              {loading ? "Deleting..." : "Delete COA"}
            </label>
          </div>
          <div style={{ marginTop: 20, paddingTop: 20, borderTop: "1px solid #ececec" }} />
        </>
      )}

      <div style={styles.formElement}>
        <label style={styles.formLabel}>Upload COA (PDF):</label>
        {/* Remove "multiple" if you only want a single file */}
        <input ref={fileInputRef} type="file" onChange={handleFileChange} accept="application/pdf" style={styles.formInput} />
      </div>
      <button type="submit" style={{ ...styles.button, backgroundColor: loading ? "silver" : "#478169" }} disabled={loading}>
        {loading ? "Uploading..." : "Upload COA"}
      </button>
    </form>
  );
};

const styles = {
  container: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    border: "1px solid #ccc",
    borderRadius: 5,
    backgroundColor: "#f9f9f9",
    width: "100%",
  },
  formElement: {
    marginBottom: 10,
  },
  formLabel: {
    marginBottom: 5,
    fontSize: 12,
    textTransform: "uppercase",
    color: "#4a4141",
  },
  formInput: {
    padding: "10px 15px",
    fontSize: 16,
    border: "0.5px solid #ccc",
    borderRadius: 5,
    width: "100%",
  },
  button: {
    padding: "0px",
    width: "120px",
    color: "white",
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
    fontSize: 14,
    height: 50,
  },
  coaPreview: {
    marginTop: 20,
    borderTop: "1px solid #eee",
    paddingTop: 10,
  },
};

export default ProductCoaTab;
